// Diskless (NSBoot) — klub egasi uchun diskless PC boshqaruvi sahifasi.
// Sahifa labs.diskless_mode === 'no' bo'lsa ko'rsatilmaydi — API 409 qaytaradi,
// biz uni yashirin xabar bilan ko'rsatamiz.
import { useState, useEffect, useCallback } from 'react';
import api from '../api';

const S = {
  page:    { padding: '0 0 32px' },
  header:  { marginBottom: 20 },
  title:   { fontSize: 22, fontWeight: 700, color: 'var(--text)' },
  sub:     { fontSize: 12, color: 'var(--text3)', marginTop: 4 },
  bar:     { display: 'flex', gap: 10, alignItems: 'center', marginBottom: 14 },
  select:  { padding: '7px 10px', background: 'var(--card2)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 8 },
  btn:     (bg='var(--cyan)', fg='#001') => ({ background: bg, color: fg, border: 0, padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 12 }),
  table:   { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th:      { textAlign: 'left', padding: '8px 10px', color: 'var(--text3)', borderBottom: '1px solid var(--border)', fontWeight: 600 },
  td:      { padding: '8px 10px', borderBottom: '1px solid var(--border)', color: 'var(--text2)' },
  badge:   (bg, fg) => ({ display: 'inline-block', padding: '2px 8px', borderRadius: 999, background: bg, color: fg, fontSize: 11, fontWeight: 600 }),
  err:     { marginBottom: 14, padding: '10px 14px', borderRadius: 10, background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.4)', color: '#ef4444', fontSize: 13 },
  info:    { marginBottom: 14, padding: '10px 14px', borderRadius: 10, background: 'rgba(0,200,255,0.06)', border: '1px solid rgba(0,200,255,0.3)', color: 'var(--text2)', fontSize: 13 },
};

export default function Diskless() {
  const [labs, setLabs] = useState([]);
  const [labId, setLabId] = useState(null);
  const [wks, setWks] = useState([]);
  const [snaps, setSnaps] = useState([]);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);  // diskless_mode='no' bo'lsa

  // Klublar ro'yxatini olish — faqat diskless_mode != 'no' bo'lganlar
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get('/owner/labs');
        const list = (r.data?.labs || r.data || []).filter(l => l.diskless_mode !== 'no');
        setLabs(list);
        if (list.length) setLabId(list[0].id);
      } catch (e) {
        setErr(e.response?.data?.error || e.message);
      }
    })();
  }, []);

  const loadWks = useCallback(async () => {
    if (!labId) return;
    setLoading(true);
    try {
      const r = await api.get(`/owner/labs/${labId}/diskless/workstations`);
      setWks(r.data.workstations || []);
      setErr('');
      setDisabled(false);
    } catch (e) {
      const st = e.response?.status;
      if (st === 409) {
        setDisabled(true);
        setWks([]);
      } else {
        setErr(e.response?.data?.error || e.message);
      }
    } finally {
      setLoading(false);
    }
  }, [labId]);

  const loadSnaps = useCallback(async () => {
    if (!labId) return;
    try {
      const r = await api.get(`/owner/labs/${labId}/diskless/snapshots`);
      setSnaps(r.data.snapshots || []);
    } catch (e) {
      // snapshot xatosi — kritik emas, log'da
      console.warn('snapshots:', e.message);
    }
  }, [labId]);

  useEffect(() => {
    if (!labId) return;
    loadWks();
    loadSnaps();
    const iv = setInterval(loadWks, 15000);
    return () => clearInterval(iv);
  }, [labId, loadWks, loadSnaps]);

  async function act(wks_id, action, confirmText) {
    if (confirmText && !window.confirm(confirmText)) return;
    try {
      await api.post(`/owner/labs/${labId}/diskless/super`, { wks_id, action });
      loadWks();
    } catch (e) {
      // Backend aniq sabab beradi — foydalanuvchiga ko'rsatamiz
      const srv = e.response?.data?.error || e.message || 'Noma\'lum xato';
      alert(`Amal rad etildi:\n\n${srv}`);
    }
  }

  async function powerOn(wks_id) {
    try {
      await api.post(`/owner/labs/${labId}/diskless/power-on`, { wks_id });
      loadWks();
    } catch (e) {
      alert(e.response?.data?.error || e.message);
    }
  }

  async function rollback(snap) {
    const anyOnline = wks.some(w => w.online);
    if (anyOnline) {
      alert('Rollback — barcha PC\'lar o\'chiq bo\'lishi kerak. Avval ularni o\'chiring.');
      return;
    }
    if (!window.confirm(`DIQQAT: ${snap} snapshot'iga qaytarilmoqda. Bu operatsiyadan keyingi hamma o'zgarishlar YO'QOLADI. Davom etilsinmi?`)) return;
    if (!window.confirm(`Yana bir marta tasdiqlang — "${snap}" ga qaytarilsin?`)) return;
    try {
      await api.post(`/owner/labs/${labId}/diskless/rollback`, { snapshot: snap });
      alert('Rollback muvaffaqiyatli');
      loadSnaps();
      loadWks();
    } catch (e) {
      alert(e.response?.data?.error || e.message);
    }
  }

  if (!labs.length) {
    return (
      <div style={S.page}>
        <div style={S.title}>💾 Diskless (NSBoot)</div>
        <div style={S.info}>Diskless rejimida ishlaydigan klub topilmadi (labs.diskless_mode = 'no').</div>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <div style={S.header}>
        <div style={S.title}>💾 Diskless (NSBoot) boshqaruvi</div>
        <div style={S.sub}>PC ro'yxati, super rejim, snapshot va rollback</div>
      </div>

      <div style={S.bar}>
        <select style={S.select} value={labId || ''} onChange={e => setLabId(parseInt(e.target.value))}>
          {labs.map(l => <option key={l.id} value={l.id}>{l.name} (#{l.id})</option>)}
        </select>
        <button style={S.btn()} onClick={loadWks} disabled={loading}>{loading ? '...' : 'Yangilash'}</button>
      </div>

      {err && <div style={S.err}>{err}</div>}

      {disabled ? (
        <div style={S.info}>Bu klub diskless rejimida emas (labs.diskless_mode='no').</div>
      ) : (
        <>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>#</th>
                <th style={S.th}>Nomi</th>
                <th style={S.th}>MAC</th>
                <th style={S.th}>IP</th>
                <th style={S.th}>Super</th>
                <th style={S.th}>Online</th>
                <th style={S.th}>Amal</th>
              </tr>
            </thead>
            <tbody>
              {wks.map(w => (
                <tr key={w.id}>
                  <td style={S.td}>{w.id}</td>
                  <td style={S.td}>{w.name} {w.computer_number ? `· #${w.computer_number}` : ''}</td>
                  <td style={S.td}><code style={{fontSize: 11}}>{w.mac || '—'}</code></td>
                  <td style={S.td}>{w.ipv4 || '—'}</td>
                  <td style={S.td}>
                    {w.supper === 1
                      ? <span style={S.badge('rgba(255,100,100,0.15)', '#f55')}>ON</span>
                      : <span style={S.badge('rgba(255,255,255,0.05)', 'var(--text3)')}>off</span>}
                  </td>
                  <td style={S.td}>
                    {w.online
                      ? <span style={S.badge('rgba(0,255,136,0.15)', 'var(--green)')}>yoniq</span>
                      : <span style={S.badge('rgba(255,255,255,0.05)', 'var(--text3)')}>o'chiq</span>}
                  </td>
                  <td style={S.td}>
                    {w.supper === 1 ? (
                      <>
                        <button style={{ ...S.btn('var(--green)', '#001'), marginRight: 6 }}
                          onClick={() => act(w.id, 'off_save',
                            "Super rejimdagi o'zgarishlarni SAQLASH tartibi:\n\n" +
                            "1) Super rejimdagi PC'ni o'chiring (Windows ichidan Shut Down)\n" +
                            "2) Boshqa PC'lar ham o'chiq ekaniga ishonch hosil qiling\n" +
                            "3) Shu tugmani bosing — server:\n" +
                            "   a) tgtadm orqali iSCSI ulanishlar bor-yo'qligini tekshiradi\n" +
                            "   b) heartbeat orqali online PC'larni tekshiradi\n" +
                            "   c) ZFS snapshot oladi (xatolik bo'lsa to'xtaydi)\n" +
                            "   d) NSBoot commit chaqiradi\n\n" +
                            "Agar birortasida ulanish qolgan bo'lsa — amal rad etiladi va PC ro'yxati ko'rsatiladi.\n\n" +
                            "Davom etilsinmi?"
                          )}>Saqlash</button>
                        <button style={S.btn('#999', '#001')}
                          onClick={() => act(w.id, 'off_discard', 'Super rejim o\'zgarishlari BEKOR qilinadi. Davom etilsinmi?')}>Bekor qilish</button>
                      </>
                    ) : (
                      <>
                        <button style={{ ...S.btn('var(--cyan)'), marginRight: 6 }}
                          onClick={() => act(w.id, 'on', 'Super rejim yoqilsinmi? Bitta PC bir vaqtda super bo\'lishi mumkin.')}>Super ON</button>
                        <button style={S.btn('var(--text3)', 'var(--text)')}
                          onClick={() => powerOn(w.id)} disabled={w.online}>WoL</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
              {!wks.length && <tr><td colSpan={7} style={{ ...S.td, textAlign: 'center', color: 'var(--text3)' }}>Hub ulanmagan yoki PC yo'q</td></tr>}
            </tbody>
          </table>

          <div style={{ marginTop: 28, ...S.header }}>
            <div style={S.title}>📸 Snapshotlar</div>
          </div>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Nomi</th>
                <th style={S.th}>Yaratilgan</th>
                <th style={S.th}>Hajmi</th>
                <th style={S.th}>Amal</th>
              </tr>
            </thead>
            <tbody>
              {snaps.map(s => (
                <tr key={s.name}>
                  <td style={S.td}><code style={{fontSize: 11}}>{s.name}</code></td>
                  <td style={S.td}>{s.creation}</td>
                  <td style={S.td}>{s.used}</td>
                  <td style={S.td}>
                    <button style={S.btn('#f55', '#fff')} onClick={() => rollback(s.name)}>Shu holatga qaytarish</button>
                  </td>
                </tr>
              ))}
              {!snaps.length && <tr><td colSpan={4} style={{ ...S.td, textAlign: 'center', color: 'var(--text3)' }}>Snapshotlar topilmadi</td></tr>}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
